import Phaser from 'phaser';

/**
 * BootScene - First scene that loads
 * Handles minimal setup before loading assets
 */
export class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: 'BootScene' });
  }

  preload(): void {
    // Load minimal assets needed for the loading screen
    // This will include a loading bar background, etc.
  }

  create(): void {
    // Set up any global game settings
    this.scale.on('resize', this.handleResize, this);

    // Proceed to preloader
    this.scene.start('PreloaderScene');
  }

  private handleResize(gameSize: Phaser.Structs.Size): void {
    // Handle any resize logic
    console.log(`Game resized to ${gameSize.width}x${gameSize.height}`);
  }
}
